import { DecimalPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { IBbitI18n } from '@bbitgmbh/bbit.utils';
import { I18nPipe } from '@bbitgmbh/website.sdk';

@Component({
  selector: 'app-credit-table',
  imports: [I18nPipe, DecimalPipe],
  templateUrl: './credit-table.component.html',
  styleUrl: './credit-table.component.scss',
})
export class CreditTableComponent {
  public credits = input<number | undefined>(1);
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: temp
  private _rowSettings: { _id: string; name: IBbitI18n; factor: number }[] = [
    // { _id: '#polyhall', name: { key: 'polyhall' }, factor: 1 },
    // { _id: '#shootingCellar', name: { key: 'shootingCellar' }, factor: 0.8 },
    // { _id: '#100mUG', name: { key: '100mUG' }, factor: 0.625 },
    // { _id: '#25mUG', name: { key: '25mUG' }, factor: 0.5 },
    // { _id: '#trainingRoom', name: { key: 'trainingRoom' }, factor: 0.16 },
  ];

  public rows = computed(() => {
    return this._rowSettings.map((row) => {
      return {
        _id: row._id,
        name: row.name,
        credits: (this.credits() || 0) * (1 / row.factor),
      };
    });
  });
}
